import React from 'react';
import logo from '../assets/logo-footer.png'; // adjust path if needed

function Footer() {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        
        {/* Logo and company info */}
        <div style={styles.section}>
          <img src={logo} alt="IndoDefTech Logo" style={styles.logo} />
          <ul style={styles.inlineList} className="w3-hide">
            <li><a href="/aboutus" style={styles.link}>About Us</a></li>
            <li><a href="/team" style={styles.link}>Team</a></li>
            <li><a href="/services" style={styles.link}>Services</a></li>
            <li><a href="/partners" style={styles.link}>Partners</a></li>
            <li><a href="/contact" style={styles.link}>Contact</a></li>
          </ul>
       
          <div style={styles.office}>
            <p style={styles.text}>AF-005-007, 1st Floor, Conscient One, Sector 109, Gurugram, Haryana 122006</p>
          </div> 
        </div>
      </div>

      {/* Bottom line */}
      <div style={styles.bottom}>
        <p style={styles.text}>
          © {new Date().getFullYear()} Gokce Capital Investments [P]Ltd. All rights reserved.         
        </p>
      </div>
    </footer>
  );
}

const styles = {
  footer: {
    backgroundColor: '#222',
    color: '#fff',
    textAlign: 'center',
    padding: '40px 20px',
  },
  container: {
    display: 'flex',
    flexDirection: 'column', // stack row by row
    alignItems: 'center',
    gap: '30px',
  },
  section: {
    maxWidth: '600px',
  },
  logo: {
    width: '120px',
    marginBottom: '10px',
    filter: 'grayscale(100%)',
  },
  heading: {
    fontSize: '18px',
    fontWeight: '700',
    margin: '10px 0',
  },
  subHeading: {
    fontSize: '16px',
    fontWeight: '600',
    margin: '8px 0',
  },
  text: {
    fontSize: '14px',
    margin: '4px 0',
  },
  inlineList: {
    listStyle: 'none',
    padding: 0,
    margin: '10px 0',
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
  },
  link: {
    color: '#fff',
    textDecoration: 'none',
    fontSize: '14px',
  },
  office: {
    marginTop: '10px',
  },
  bottom: {
    borderTop: '1px solid #444',
    marginTop: '30px',
    paddingTop: '15px',
  },
};

export default Footer;
